import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

import { Promo } from '@libs/models';
import { usePromoSearchQuery } from '@carcareers/store';
import { Drawer, PromoForm, DataGridV2 as DataGrid, DashboardPageContainer } from '@carcareers/components';
import { usePromo } from '@carcareers/hooks';
import { PROMO_INDEX_COLUMNS, PROMO_INDEX_COLUMN_INITIAL_STATE, routes } from '@carcareers/utils';
import { FormProvider, useDrawer } from '@carcareers/contexts';
import { Delete, Visibility } from '@mui/icons-material';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';

export const PromoIndex: FC = () => {
  const navigate = useNavigate();
  const searchPromo = usePromoSearchQuery;
  const { deletePromo, activatePromo, deactivatePromo } = usePromo();
  const { setOpen } = useDrawer();

  const columns = [
    ...PROMO_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() => {
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_PROMOS_VIEW.replace(':id', params.row.id.toString())}`);
          }}
        />,
        ...(!params.row.isActive
          ? [
              <GridActionsCellItem
                showInMenu
                key={`activate-${params.row.id}`}
                label="Activate"
                icon={<PlayArrowIcon />}
                onClick={() => {
                  activatePromo(params.row.id);
                }}
              />,
            ]
          : []),
        ...(params.row.active
          ? [
              <GridActionsCellItem
                showInMenu
                key={`deactivate-${params.row.id}`}
                label="Deactivate"
                icon={<PauseIcon />}
                onClick={() => {
                  deactivatePromo(params.row.id);
                }}
              />,
            ]
          : []),
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => {
            deletePromo(params.row.id);
          }}
        />,
      ],
    },
  ];

  return (
    <>
      <DashboardPageContainer>
        <DataGrid<Promo>
          columns={columns}
          query={searchPromo}
          tools={
            <>
              <Button onClick={() => setOpen(true)} variant="contained" color="primary">
                Add
              </Button>
              <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
            </>
          }
          initialState={{
            columns: {
              columnVisibilityModel: PROMO_INDEX_COLUMN_INITIAL_STATE,
            },
          }}
        />
      </DashboardPageContainer>
      <Drawer title="Add Promo" width={500}>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', p: 2 }}>
            <PromoForm />
          </Box>
        </FormProvider>
      </Drawer>
    </>
  );
};

export default PromoIndex;
